import React, {useImperativeHandle, useContext, useState, useRef, forwardRef, useEffect} from "react";

import {View, Text, TextInput}  from 'react-native';

import {estilos} from '../util/estilos'

import * as texto from '../util/texto'

import * as data from '../util/data'

import cores from '../util/cores'

import Botao from '../componentes/Botao'

import RotuloErro from '../componentes/RotuloErro'

import {ITEM_TIPO_PRODUTO, ITEM_TIPO_SERVICO, TIPO_CAMERA_PEDIDO, TELA_CAMERA} from '../util/constantes'

import * as util from '../util/util'

import * as validacao from '../util/validacao'

import CampoNumero from '../componentes/CampoNumero'

import {semDados} from '../componentes/SemDados'

import ComponenteCategoria from '../componentes/ComponenteCategoria'

import {MaskedTextInput} from "react-native-mask-text";

import FormularioSelecionarItem, {TIPO_SELECAO_ITEM} from '../componentes/FormularioSelecionarItem'

import Scroll from '../componentes/Scroll'

import Bloco from '../componentes/Bloco'

import Combo from '../componentes/Combo'

import Alerta from '../componentes/Alerta'

import Upload from '../componentes/Upload'



const FormularioPedido = forwardRef((props, ref) => {
	
	const [titulo, setTitulo] = useState(null)
	const [descricao, setDescricao] = useState(null)
	const [itens, setItens] = useState([])
	const [dataExpiracao, setDataExpiracao] = useState(null)
	const [msgErro, setMsgErro] = useState(null)
	const [editando, setEditando] = useState(false)
	const [itemId, setItemId] = useState(null)
	const [itemTipo, setItemTipo] = useState(ITEM_TIPO_PRODUTO)
	const [itemNome, setItemNome] = useState(null)
	const [itemDescricao, setItemDescricao] = useState(null)
	const [itemQuantidade, setItemQuantidade] = useState(1)
	const [itemMarca, setItemMarca] = useState(null)
	const [itemModelo, setItemModelo] = useState(null)
	const [itemCor, setItemCor] = useState(null)
	const [itemTamanho, setItemTamanho] = useState(null)
	const [itemObs, setItemObs] = useState(null)
	const [itemIdCategoria, setItemIdCategoria] = useState(null)
	const [itemIdSubcategoria, setItemIdSubcategoria] = useState(null)
	const [selecionarProdutoServico, setSelecionarProdutoServico] = useState(false)


	const btSalvarRef  = useRef(null)
	const componenteCategoriaRef  = useRef(null)	
	const blockBackRef = useRef(false);

	const [arquivo, setArquivo] = useState(null)
	


	useImperativeHandle(ref, () => ({
		setDados: () => setDados(titulo, descricao, itens),
		getDados: () => getDados(),
		salvarErro: (mensagem) => salvarErro(mensagem),
		salvarSucesso: () => salvarSucesso(),
		editando: () => {return blockBackRef.current==true},
		cancelarEdicao: () => {
			
			limpaItem();

			blockBackRef.current = false;

			setEditando(false)
			setSelecionarProdutoServico(false)	
		}
	}));
	
	
	const setDados=(titulo, descricao, itens)=>{
	
		setTitulo(titulo)
		setDescricao(descricao)
		setItens(itens)
		setMsgErro(null)
    }
	
	
	const getDados=()=>{

		return {
			titulo: titulo,
			descricao: descricao,
			itens: itens	
        };
    }
	
	
	const validar=()=>{
		
		btSalvarRef.current.setCarregando(true)
	
        if(texto.isBlanck(titulo)){

            salvarErro("Informe o título do pedido.");
            return;
        } 
		
		if(texto.isBlanck(descricao)){

            salvarErro("Informe o descrição do pedido.");
            return;
        } 
		
		let data_expiracao_formatado = data.converteDataBrParaEua(dataExpiracao);
		
		if(texto.isBlanck(data_expiracao_formatado)){

            salvarErro("Informe a data de expiração.");
            return;
        }
		
		if(!validacao.validarDataEua(data_expiracao_formatado)){

            salvarErro("Data de expiração inválida.");
            return;
        }
		
		if(data.compararDatas(data.getDataAtual(false), data_expiracao_formatado)>=0){

            salvarErro("Data de expiração dever ser pelo menos um dia maior que a data atual.");
            return;
        }
		
		if(!util.temConteudo(itens)){
			
			salvarErro("Adicione ao menos um item de pedido.");
            return;
		}

		Alerta("Revise os dados",
				"Após o envio do pedido não será possível alterá-lo, deseja prosseguir?", 
				async ()=>salvarPedido());
	}
	
	
	const salvarPedido=async()=>{
	
		await props.salvar({"titulo": titulo, 
								"descricao": descricao, 
									"data_expiracao": data.converteDataBrParaEua(dataExpiracao), 
										"itens": itens,
											"imagem": arquivo});
	}
	
	
	const salvarErro=(mensagem)=>{
		
		btSalvarRef.current.setCarregando(false);
		setMsgErro(mensagem);
    }


	const salvarSucesso=()=>{
		
		btSalvarRef.current.setCarregando(false);
		setMsgErro(null);
	}
	
	
	const salvarItem=()=>{
	
		setMsgErro(null);
	
        if(texto.isBlanck(itemNome)){

            salvarErro("Informe o nome do item.");
            return;
        } 

		let categoria = componenteCategoriaRef.current?
							componenteCategoriaRef.current.getDados():null;
		
		if(categoria==null || texto.isBlanck(categoria.id_categoria)){

            salvarErro("Selecione a categoria do item.");
            return;
        }
		
		if(itemId==null)
			setItens(prevItems => [...prevItems, {"id": null,	
													"tipo": itemTipo, 
														"nome": itemNome, 
															"descricao": itemDescricao, 
																"quantidade": itemQuantidade==null?1:itemQuantidade,
																	"id_categoria": categoria.id_categoria,
																		"id_subcategoria": categoria.id_subcategoria,
																			"marca": itemMarca,
																		"modelo": itemModelo,
																	"cor": itemCor,
																"tamanho": itemTamanho,
															"obs": itemObs}]);
		
		limpaItem();
		
		setEditando(false)
	}


	const limpaItem=()=>{
	
		setItemId(null)
		setItemTipo(ITEM_TIPO_PRODUTO)
		setItemNome(null)
		setItemDescricao(null)
		setItemQuantidade(1)
		setItemMarca(null)
		setItemModelo(null)
		setItemCor(null)
		setItemTamanho(null)
		setItemObs(null)
		setItemIdCategoria(null)
		setItemIdSubcategoria(null)
	}
	
	
	const editarItem=(item)=>{
	
		setMsgErro(null);
	
		if(item==null)
			limpaItem();
		else{
			
			setItemId(item.id)
			setItemTipo(item.tipo)
			setItemNome(item.nome)
			setItemDescricao(item.descricao)
			setItemQuantidade(item.quantidade)
			setItemMarca(item.marca)
			setItemModelo(item.modelo)
			setItemCor(item.cor)
			setItemTamanho(item.tamanho)
			setItemObs(item.obs)
			setItemIdCategoria(item.fk_categoria)
			setItemIdSubcategoria(item.fk_subcategoria)
		}
		
		blockBackRef.current = true;

		setEditando(true)	
	}
   
	
	useEffect(() => {
  
		util.print("FormularioPedido update "+editando);
		
		if(editando ==true){
			
			util.print("FormularioPedido atualizarCategoria "+itemIdCategoria+" "+itemIdSubcategoria);
		
			if(componenteCategoriaRef.current){
				
				util.print("FormularioPedido atualizarCategoria componente ok");
				
				componenteCategoriaRef.current.setDados(itemTipo, itemIdCategoria, itemIdSubcategoria);
			}
		}
			
	}, [editando, selecionarProdutoServico]); 
	
	
	const excluirItem=(index)=>{

		setItens(prevItems => prevItems.filter((_, i) => i !== index));
	}
   
   
	function itemLista(item, index){

		let infos = util.outrasInfosItem(item);

		return (
			<Bloco key={index}> 
				<View style={{marginTop:10}}/>  
				<Text style={estilos.rotulo_titulo}>{item.nome}</Text>
				<Text style={estilos.rotulo_padrao}>{util.substring(item.descricao, 60)}</Text>
				{util.temConteudo(infos) && <Text style={estilos.rotulo_padrao}>{infos}</Text>}
				
				<Text style={estilos.rotulo_padrao}>QTDe {item.quantidade}</Text>
				<View style={{marginTop:10}}/>
				<View style={estilos.grade}>
					<View style={[estilos.coluna, {alignItems:'flex-start'}]}>
						<Botao
							acao={()=>editarItem(item)}
							texto="Editar"
							somente_texto={true}
							cor={cores.azul}/> 
					</View>
					
					<View style={estilos.coluna}/> 
					
					<View style={[estilos.coluna, {alignItems:'flex-end'}]}>
						<Botao
							acao={()=>excluirItem(index)}
							texto="Excluir"
							somente_texto={true}
							cor={cores.vermelho}/> 
					</View>
				</View>	
				<View style={{marginTop:5}}/>
			</Bloco>)
	}


	const mudouTipo=(novoTipo)=>{
	
		setItemTipo(novoTipo)
		
		if(componenteCategoriaRef.current)
			componenteCategoriaRef.current.setDados(novoTipo, null, null);	
	}

	
	function selecionarProdutoRetorno(item){

		setItemTipo(item.tipo)
		setItemNome(item.nome)
		setItemDescricao(item.descricao)
		setItemMarca(item.marca)
		setItemModelo(item.modelo)
		setItemCor(item.cor)
		setItemTamanho(item.tamanho)
		setItemIdCategoria(item.fk_categoria)
		setItemIdSubcategoria(item.fk_subcategoria)
		
		setSelecionarProdutoServico(false)
	}
	
	
	function formularioEditarItem(){
	
		let dados = [{'id': ITEM_TIPO_PRODUTO, 'nome': "Produto"}, 
								{'id': ITEM_TIPO_SERVICO, 'nome': "Serviço"}];

		return (
			(selecionarProdutoServico)?
				(<FormularioSelecionarItem tipo={TIPO_SELECAO_ITEM} selecionar={selecionarProdutoRetorno}/>):
				(<Scroll> 
					<Bloco>             		
						<View style={{marginTop:10}}/>  
							
						<View style={{alignItems:'center'}}>
							<Text style={estilos.rotulo_titulo}>{itemId!=null?"Edição de Item":"Novo Item"}</Text>	    
						</View>

						<View style={{marginTop:20}}/> 

						<View style={{alignItems:'center'}}>

							<Text style={estilos.rotulo_padrao}>Selecionar a partir de produtos/serviços:</Text>

							<Botao 
								acao={()=>setSelecionarProdutoServico(true)}
								texto="Selecionar Produto/Serviço"
								ref={btSalvarRef}/>    
						</View>
							
							
						<View style={{marginTop:30}}/> 
						<View style={estilos.separador}/>
						<View style={{marginTop:30}}/> 

						<Combo 
							mostrarVazio = {false}
							rotulo="Tipo:"
							dados={dados} 
							aoMudar={(valor)=>mudouTipo(valor.id)}
							selecionado={itemTipo}/>

						<View style={{marginTop:20}}/> 

						<Text style={estilos.rotulo_padrao}>Nome:</Text>
													
						<TextInput
								placeholder=""
								style={estilos.campo_padrao} 
								multiline={false}
								onChangeText={(text)=>setItemNome(text)}
								maxLength={150}
								value={itemNome}/>
									
						<View style={{marginTop:30}}/>  

						<Text style={estilos.rotulo_padrao}>Descrição:</Text>
													
						<TextInput
								placeholder=""
								style={estilos.campo_padrao} 
								multiline={true}
								numberOfLines = {4}
								onChangeText={(text)=>setItemDescricao(text)}
								maxLength={250}
								value={itemDescricao}/>
						
						<View style={{marginTop:30}}/>  

						<ComponenteCategoria ref={componenteCategoriaRef}/>
						
						<View style={{marginTop:30}}/>  				
						
						<Text style={estilos.rotulo_padrao}>Quantidade (opcional):</Text>
													
						<CampoNumero
								valor={itemQuantidade}
								setValor={(valor)=>setItemQuantidade(valor)}/>
												
						<View style={{marginTop:30}}/>  
							
						<Text style={estilos.rotulo_padrao}>Marca (opcional):</Text>
													
						<TextInput
								placeholder=""
								style={estilos.campo_padrao} 
								multiline={false}
								onChangeText={(text)=>setItemMarca(text)}
								maxLength={100}
								value={itemMarca}/>
										
						<View style={{marginTop:30}}/>    

						<Text style={estilos.rotulo_padrao}>Modelo (opcional):</Text>
													
						<TextInput
								placeholder=""
								style={estilos.campo_padrao} 
								multiline={false}
								onChangeText={(text)=>setItemModelo(text)}
								maxLength={100}
								value={itemModelo}/>
								
						<View style={{marginTop:30}}/>    

						<Text style={estilos.rotulo_padrao}>Cor (opcional):</Text>
													
						<TextInput
								placeholder=""
								style={estilos.campo_padrao} 
								multiline={false}
								onChangeText={(text)=>setItemCor(text)}
								maxLength={100}
								value={itemCor}/>
								
						<View style={{marginTop:30}}/>    

						<Text style={estilos.rotulo_padrao}>Tamanho (opcional):</Text>
													
						<TextInput
								placeholder=""
								style={estilos.campo_padrao} 
								multiline={false}
								onChangeText={(text)=>setItemTamanho(text)}
								maxLength={100}
								value={itemTamanho}/>
								
						<View style={{marginTop:30}}/>    

						<Text style={estilos.rotulo_padrao}>Observação (opcional):</Text>
													
						<TextInput
								placeholder=""
								style={estilos.campo_padrao} 
								multiline={false}
								onChangeText={(text)=>setItemObs(text)}
								maxLength={150}
								value={itemObs}/>
							
						<View style={{marginTop:10}}/>

						{msgErro!=null &&	
							<View style={{alignItems:'center'}}>
								<RotuloErro mensagem={msgErro}/>
							</View>
						}

						<View style={{marginTop:10}}/>
						
						<View style={{alignItems:'center'}}>
							<Botao 
								acao={()=>salvarItem()}
								texto="Salvar Item"/>    
						</View>

						<View style={{marginTop:30}}/>
					</Bloco>
				</Scroll>)
		)	
	}


	const enviarImagem= async (arquivo)=>{
		
		setArquivo(arquivo);
	};


	return (
		(editando)?
			(formularioEditarItem()):
			(<Scroll>
				<View>  
					<Bloco> 
						<View style={{marginTop:10}}/>  
						<View style={{alignItems:'center'}}>
							<Text style={estilos.rotulo_titulo}>Dados Gerais</Text>	    
						</View>
							
						<View style={{marginTop:10}}/>   
										
						<Text style={estilos.rotulo_padrao}>Título:</Text>
																
						<TextInput
							placeholder=""
							style={estilos.campo_padrao} 
							multiline={false}
							onChangeText={(text)=>setTitulo(text)}
							maxLength={250}
							value={titulo}/>
								   
						<View style={{marginTop:10}}/>   
										
						<Text style={estilos.rotulo_padrao}>Descrição:</Text>
																
						<TextInput
							placeholder=""
							style={estilos.campo_padrao} 
							multiline={true}
							numberOfLines = {4}
							onChangeText={(text)=>setDescricao(text)}
							maxLength={250}
							value={descricao}/>
						
						<View style={{marginTop:10}}/>   
										
						<Text style={estilos.rotulo_padrao}>Data da Expiração:</Text>
						
						<MaskedTextInput  
							placeholder="" 
							mask="99/99/9999"
							style={[estilos.campo_padrao, {width: '70%'}]} 
							onChangeText={(text, rawText)=>setDataExpiracao(rawText === ''?null:rawText)}
							keyboardType="numeric"
							value={dataExpiracao}/>
						
						<View style={{marginTop:10}}/>
					</Bloco>
						
					<View style={{alignItems:'center'}}>
						<View style={{marginTop:15}}/>
						<Botao 
							acao={()=>editarItem(null)}
							texto="Novo Item"/>   
						<View style={{marginTop:15}}/>	
					</View>
					
					{(util.temConteudo(itens))?
						(itens.map((item, index) => itemLista(item, index))):
						(<Bloco> 
							<View style={{marginTop:10}}/>
							{semDados("info", "Nenhum item adicionado.", 60)}
							<View style={{marginTop:10}}/>	
						</Bloco>)
					}
					<Bloco>
						<View style={{marginTop:10}}/>  
						
						<View style={{alignItems:'center'}}>
							<View style={{marginTop:10}}/>  
							<Text style={estilos.rotulo_titulo}>Foto de Pedido (opcional)</Text>
							<View style={{marginTop:20}}/>  	
							
							<View style={{alignItems:'center'}}>
								<Upload acaoRecebimentoArquivo={(arquivo)=>enviarImagem(arquivo)}/>
							</View>
							<View style={{marginTop:20}}/>  
						</View>	
						<View style={{marginTop:10}}/>  
					</Bloco>
					<Bloco> 
						<View style={{marginTop:10}}/>  

						{util.temConteudo(msgErro) && 
							<View style={{alignItems:'center'}}>
								<View style={{marginTop:10}}/>
								<RotuloErro mensagem={msgErro}/>
							</View>
						}
						
						<View style={{alignItems:'center'}}>
							<Botao 
								acao={()=>validar()}
								texto="Salvar Pedido"
								ref={btSalvarRef}/>   
						</View>	
							
						<View style={{marginTop:10}}/>
					</Bloco>
				</View>
			</Scroll>)
	);
});

export default FormularioPedido;